import Vue from 'vue'
import './assets/css/style.css'

import router from './router/router.js'   // ���ݲ�ͬ��Ŀ, ���벻ͬ�����

import FrameApp from './FrameApp'

import  VueResource  from 'vue-resource'
Vue.use(VueResource)

Vue.config.productionTip=false;

Vue.directive('title', {
	inserted: function (el, binding) {
		document.title = el.dataset.title;
	}
})

new Vue({
	el: '#idVUEApp',
	router,
	//render: h => h(FrameApp),
	template: '<FrameApp/>',
	components: { FrameApp },
})



// WEBPACK FOOTER //
// ./src/main.js